import gsap from 'gsap'

import ee from '../ee'

function fadeInOnScroll(section) {
  return gsap
    .timeline({
      scrollTrigger: {
        trigger: section,
        start: '50px bottom',
        once: true,
      },
    })
    .to(section, {
      autoAlpha: 1,
      ease: 'linear',
      duration: 1,
    })
}

function init() {
  let sections = Array.from(document.querySelectorAll('.c-section'))
  sections.forEach((section) => {
    fadeInOnScroll(section)
  })
}

ee.addListener('initComponents', init)
